import { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';
import { toast } from 'sonner';

const POLL_INTERVAL = 30 * 1000; // 30s

export function useNewOrdersPolling() {
  const [newOrdersCount, setNewOrdersCount] = useState(0);
  const knownIdsRef = useRef(new Set());
  const initializedRef = useRef(false);

  const poll = useCallback(async () => {
    try {
      const res = await api.get('/pedidos', { params: { status: 'Recebido', per_page: 50, page: 1 } });
      const raw = res.data;
      const pedidos = Array.isArray(raw) ? raw : (raw.pedidos || []);
      const currentIds = new Set(pedidos.map(p => p.id));

      if (!initializedRef.current) {
        // First call: seed known IDs silently (don't notify for existing orders)
        knownIdsRef.current = currentIds;
        initializedRef.current = true;
        return;
      }

      const newOnes = pedidos.filter(p => !knownIdsRef.current.has(p.id));
      if (newOnes.length > 0) {
        newOnes.forEach(p => {
          const num = String(p.numero || '').padStart(3, '0') || p.id?.slice(-4) || '???';
          toast.success(`Novo pedido recebido #${num}`, {
            description: `Cliente: ${p.cliente_nome || 'Cliente'}`,
            duration: 6000,
          });
        });
        setNewOrdersCount(prev => prev + newOnes.length);
      }

      knownIdsRef.current = currentIds;
    } catch {
      // Silently fail — don't interrupt UX
    }
  }, []);

  const clearCount = useCallback(() => setNewOrdersCount(0), []);

  useEffect(() => {
    poll(); // immediate seed on mount
    const interval = setInterval(poll, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [poll]);

  return { newOrdersCount, clearCount };
}
